import React from "react";
import DisplayWeather from "./components/DisplayWeather";
import  "./App.css"

function App() {
  return (
    <div className="App">
      <DisplayWeather />
    </div>
  );
}

export default App;
